import { render, staticRenderFns } from "./StoreComparisonTable.vue?vue&type=template&id=c804ae54&"
import script from "./StoreComparisonTable.vue?vue&type=script&lang=js&"
export * from "./StoreComparisonTable.vue?vue&type=script&lang=js&"
import style0 from "./StoreComparisonTable.vue?vue&type=style&index=0&id=c804ae54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QMenu,QList,QItem,QItemSection,QToggle,QTable,QTr,QTh,QTd,QPagination,QInnerLoading,QSpinnerTail,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QMenu,QList,QItem,QItemSection,QToggle,QTable,QTr,QTh,QTd,QPagination,QInnerLoading,QSpinnerTail})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
